import mixpanel, { type RequestOptions } from 'mixpanel-browser';

const init = (): void => {
  const mixpanelToken = Env.MIXPANEL_TOKEN;
  if (mixpanelToken && mixpanelToken !== '') {
    mixpanel.init(mixpanelToken, {
      api_host: 'https://api-eu.mixpanel.com',
      ignore_dnt: true,
      debug: false,
    });
  }
};

const checkAndRun = (fn: () => void): void => {
  try {
    fn();
  } catch (e) {
    init();
    fn();
  }
};

const sendEventLogin = (properties?: any): void => {
  checkAndRun(() => mixpanel.track('USER: LOGIN', properties || null));
};

const sendEventLogout = (properties?: any): void => {
  checkAndRun(() => mixpanel.track('USER: LOGOUT', properties || null));
  mixpanel.reset();
};

const sendEvent = (name: string, properties?: any, options?: RequestOptions): void => {
  checkAndRun(() => mixpanel.track(name, properties || null, options));
};

const recordPageView = () => {
  checkAndRun(() => mixpanel.track_pageview());
};

const identifyUser = (id: string) => {
  checkAndRun(() => mixpanel.identify(id));
};

export const Analytics = {
  init,
  sendEvent,
  recordPageView,
  identifyUser,
  sendEventLogin,
  sendEventLogout,
};
